import { FileTextIcon, ZapIcon, BotIcon, SmartphoneIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Works with ChatGPT, Claude, Gemini & DeepSeek'
}, {
  icon: SmartphoneIcon,
  label: 'Designed for Digital & Mobile Access'
}];
export const stats = [{
  value: '500+',
  label: "Satisfied\xA0Authors"
}, {
  value: '6+4',
  label: 'Volumes + Bonuses'
}, {
  value: "99%",
  label: "Success Rate"
}, {
  value: '4.9/5',
  label: "⭐ Global rating"
}];